import { makeStyles, createStyles } from '@material-ui/core/styles'

export const useAutocompleteWrapperStyles = makeStyles((theme) =>
  createStyles({
    checkbox: {
      marginRight: theme.spacing(1)
    },

    inputRoot: {
      flexWrap: 'nowrap'
    },

    chip: {
      userSelect: 'none',
      cursor: 'pointer'
    }
  })
)
